import { render, staticRenderFns } from "./SelectInputConfig.vue?vue&type=template&id=80150b0a&"
import script from "./SelectInputConfig.vue?vue&type=script&lang=js&"
export * from "./SelectInputConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports